import { useGSAP } from '@gsap/react';
import { PortableText } from '@portabletext/react';
import { graphql } from 'gatsby';
import gsap from 'gsap';

import React, { useRef } from 'react';
import { getComponents } from '../../../portableText';
import { RawPortableText } from '../../../types/types';
import { CommonModuleProps } from '../../ModulesContent';
import Accordion from '../Accordion';
import ModuleLayout from '../ModuleLayout';
import * as styles from './AccordionModule.module.scss';

export const AccordionModuleFragment = graphql`
  fragment AccordionModule on SanityAccordionModule {
    title {
      ...LocaleStringFragment
    }
    accordions {
      title {
        ...LocaleStringFragment
      }
      text {
        ...LocaleListPortableText
      }
    }
  }
`;

export type AccordionModuleProps = {
  title?: string;
  accordions: Array<{
    title: string;
    text: RawPortableText;
  }>;
  className?: string;
};

function AccordionModule(props: AccordionModuleProps & CommonModuleProps): React.ReactElement {
  const { title, accordions, className, moduleId } = props;
  const containerRef = useRef<HTMLElement | null>(null);

  useGSAP(
    () => {
      gsap.from(`.${styles.accordion}`, {
        x: 200,
        opacity: 0,
        duration: 0.8,
        ease: 'power1.out',
        stagger: 0.2,
        scrollTrigger: {
          trigger: `.${styles.accordionsContainer}`,
          start: 'top 80% ',
        },
      });
    },
    { scope: containerRef },
  );

  return (
    <ModuleLayout
      id={moduleId}
      ref={containerRef}
      className={className}
      childrenClassName={styles.contentContainer}
      currentModuleBgColor={props.theme}
    >
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.accordionsContainer}>
        {accordions.map((accordion, i) => (
          <Accordion title={accordion.title} key={i} className={styles.accordion}>
            <div className={styles.text}>
              <PortableText value={accordion.text} components={getComponents()} />
            </div>
          </Accordion>
        ))}
      </div>
    </ModuleLayout>
  );
}

export default AccordionModule;
